import React, { useContext } from 'react';
import { MyContext } from '../../context';
import './Aicomponent.css';
import AiImage from '../../assets/images/Ai/aiImage.png';

const AiComponent = () => {
  const { pageData } = useContext(MyContext);

  return (
    <section className="ai-section">
      <div className="container" style={{ marginBottom: '25px' }}>
        <div className="ai-header-section">
          <div>
            <h2 style={{ color: 'white' }}>{pageData?.aiComponent?.header}</h2>
            <p style={{ color: 'white' }}>
              {pageData?.aiComponent?.description}
            </p>
          </div>
          <img loading="lazy" src={AiImage} width="250px" alt=""></img>
        </div>
        <div className="ai-cards-container">
          {pageData?.aiComponent?.cardData?.map((item, index) => (
            <div key={index}>
              <h4 style={{ color: 'white' }}>{item?.header}</h4>
              <p style={{ color: 'white', fontFamily: 'matterMedium' }}>
                {item?.subtitle}
              </p>
              <p style={{ padding: '0px', color: 'white' }}>
                {item?.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default AiComponent;
